import type { UseFormSetError } from 'react-hook-form';

import type { Renter } from '@/utils/types/renter.interface';

type SetErrorFn = UseFormSetError<Renter>;

export type SubmitErrorData = {
  message?: string;
  field_errors?: Array<{ field: string; message: string }>;
  fault?: { messages?: object };
};

// Maps DD service / invite-service field_errors names to React Hook Form paths
const API_TO_FORM_FIELD: Record<string, string> = {
  gross_monthly_rent: 'grossMonthlyRent',
  lease_start: 'leaseStart',
  lease_end: 'leaseEnd',
  prepaid_rent: 'prepaidRent',
  free_rent: 'freeRent',
  unit: 'apartmentNumber',
  screening_status: 'approvalStatus',
  'coverage.lease_guarantee.coverage_amount': 'monthsOfCoverage',
  'coverage.security_deposit_replacement.coverage_amount': 'securityDepositReplacementAmount',
};

const mapApiFieldToFormField = (apiField: string): string | null => {
  const applicantMatch = /^invite_recipients\.(\d+)\.email$/.exec(apiField);
  if (applicantMatch) return `applicantEmails.${applicantMatch[1]}.value`;
  if (apiField === 'email') return 'applicantEmails.0.value';

  return API_TO_FORM_FIELD[apiField] ?? null;
};

export const applyInviteServiceFieldErrors = (
  fieldErrors: Array<{ field: string; message: string }>,
  setError: SetErrorFn,
): Array<{ formField: string; message: string }> => {
  const applied: Array<{ formField: string; message: string }> = [];
  fieldErrors.forEach(({ field, message }) => {
    const formField = mapApiFieldToFormField(field);
    if (!formField) return;
    setError(formField as Parameters<SetErrorFn>[0], { message });
    applied.push({ formField, message });
  });
  return applied;
};
